import React from 'react'

interface LogoProps {
  className?: string
}

export function Logo({}: LogoProps) {
  //return <Image src={images.logo} height={50} alt="logo" />
  return <></>
}
